export const MISSING_REQUIRED_HEADERS = 'MISSING_REQUIRED_HEADERS';
export const NOT_FOUND = 'NOT_FOUND';
export const UNEXPECTED_ERROR = 'UNEXPECTED_ERROR';
export const VALIDATION_ERROR = 'VALIDATION_ERROR';
export const TEMPLATE_COMPILE_ERROR = 'TEMPLATE_COMPILE_ERROR';
export const DATABASE_ERROR = 'DATABASE_ERROR';

export const INVALID_INPUT_MSG = 'The provided input is invalid';
export const MISSING_TENANT_HEADERS_MSG = 'Tenant ID and User ID are required';
export const ROUTE_NOT_FOUND_MSG = 'Route not found';
export const UNEXPECTED_ERROR_MSG = 'An unexpected error occurred';
export const TEMPLATE_COMPILE_ERROR_MSG = 'Template compilation error occurred';
